import React from 'react'
import Unpaz from '../../assets/images/unpaz.jpg'

const Educacion = () => {
  return (
    <div>

<section id="educacion">
        <div className="container">
            <h3 className="my-3 my-sm-5 title"><i className="fa-solid fa-graduation-cap" style={{ "margin-right": "5px" }} ></i>Formacion
                Academica </h3>
            <div className="row shadow">
                <div className="col-12 col-sm-7 pt-4">
                    <div className="row">
                        <div className="unpaz col-sm-3  d-none d-sm-block">
                            <img src={Unpaz} width="130" alt=""/>
                        </div>
                        <div className="titles col-sm-9 py-3">
                            <h3>Universidad Nacional de José C. Paz</h3>
                            <h4>Analistas de Sistemas (Nivel Inicial)</h4>
                            <h5>2021 - Actualidad</h5>
                            <p><a href="https://www.unpaz.edu.ar/">UNPAZ</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Educacion